<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/W08bLN/tc-custom/9781466860421.jpg?1731151204089" alt="This image is the cover for the book Sinner's Steel, The Sinner's Tribe Motorcycle Club"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sinner's Steel, The Sinner's Tribe Motorcycle Club
      </h1>
      <p class="bookDescription body article font2">
        <p><b>HE'S HELL ON WHEELS.</b><br/> Tall, dark, and dangerously handsome, Zane "Tracker" Colter is the strong, silent type of tattooed muscle biker who drives women wild. But as a master of strategy for the outlaw MC club, Sinner's Tribe, he doesn't have time to play around with groupies and biker chicks-especially when he can't stop thinking about Evie, the girl who got away...<br/><br/><b>SHE'S PLAYING WITH FIRE.</b><br/> Evie's been in love with Zane ever since they were children-until he broke her heart and disappeared. Now he's back in her life, bigger and badder than ever. Zane is stunned by how beautiful and confident Evie's become, using her artistic talent to customize motorcycles. He wants her so bad, he'd ride through fire to win her back. There's one problem: Evie is dating his deadliest rival-the leader of the Black Jacks-and if Evie and Zane hook up, there'll be hell to pay... in <i>Sinner's Steel.</i><br/><br/><b>Sarah Castille's Sinner's Tribe series is:</b><br/><br/> "Raw, rugged, and romantic." -Eden Bradley, <i>New York Times</i> bestselling author <br/> "A sexy and dangerous ride!"-Roni Loren, <i>New York Times</i> bestselling author</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Castille
      </h2>
      
      <p class="authorDescription body article"><I>New York Times</I> and <I>USA Today </I>bestselling author of the dark, gritty biker romances, <I>Rough Justice </I>and <I>Beyond the Cut</I>,  Sarah Castille, worked and travelled abroad before trading her  briefcase and stilettos for a handful of magic beans and a home near the  Canadian Rockies. She writes contemporary romance and romantic suspense  featuring blazingly hot alpha heroes and the women who tame them.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d4975302